<script setup>
import { defineProps } from 'vue'
import DocSection from '@/components/Docs/Section.vue'
import CodeBlock from '@/components/Docs/CodeBlock.vue'

defineProps({ anchor: String })
</script>

<template>
  <doc-section title="Authentication" :anchor="anchor">
    <template v-slot:left>
      <p>
        Most endpoints require authentication. The primary method for external
        systems is an <strong>API key</strong>, passed as the
        <code>apikey</code> query parameter on any request. The key is a 40-character
        token that identifies your account and governs which endpoints and datasets
        you can reach.
      </p>
      <p>
        Generate and manage keys from your
        <router-link to="/account">account screen</router-link> once logged in.
        Store the key securely, anyone with it can act as your account, and you
        will not be able to view it again after it is created.
      </p>
      <p>
        Browser sessions may alternatively authenticate with a JWT via the
        <code>Authorization: Bearer &lt;token&gt;</code> header; the live examples in
        this reference use your current session automatically.
      </p>
    </template>

    <template v-slot:right>
      <code-block title="API key (query parameter)" text>
        https://api.webscout.io/query/ip/8.8.8.8?apikey={YOUR_APIKEY}
      </code-block>

      <code-block title="JWT (header)" text>
        Authorization: Bearer {YOUR_JWT}
      </code-block>
    </template>
  </doc-section>
</template>
